/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { MockLendingPool } from '../MockLendingPool'

export class MockLendingPool__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer)
  }

  deploy(
    _usdc: string,
    _weth: string,
    overrides?: Overrides
  ): Promise<MockLendingPool> {
    return super.deploy(
      _usdc,
      _weth,
      overrides || {}
    ) as Promise<MockLendingPool>
  }
  getDeployTransaction(
    _usdc: string,
    _weth: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_usdc, _weth, overrides || {})
  }
  attach(address: string): MockLendingPool {
    return super.attach(address) as MockLendingPool
  }
  connect(signer: Signer): MockLendingPool__factory {
    return super.connect(signer) as MockLendingPool__factory
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockLendingPool {
    return new Contract(address, _abi, signerOrProvider) as MockLendingPool
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'contract ERC20',
        name: '_usdc',
        type: 'address'
      },
      {
        internalType: 'contract ERC20',
        name: '_weth',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'asset',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'interestRateMode',
        type: 'uint256'
      },
      {
        internalType: 'uint16',
        name: 'referralCode',
        type: 'uint16'
      },
      {
        internalType: 'address',
        name: 'onBehalfOf',
        type: 'address'
      }
    ],
    name: 'borrow',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'asset',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: 'onBehalfOf',
        type: 'address'
      },
      {
        internalType: 'uint16',
        name: 'referralCode',
        type: 'uint16'
      }
    ],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'asset',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: 'onBehalfOf',
        type: 'address'
      }
    ],
    name: 'repay',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'usdc',
    outputs: [
      {
        internalType: 'contract IERC20',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'weth',
    outputs: [
      {
        internalType: 'contract IERC20',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'asset',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      }
    ],
    name: 'withdraw',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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'
